<template>
 <div>
  <multiselect
    v-model="$store.state.valueMunicipality"
    :options="options" 
    @input="onChange"
    placeholder="Selecciona Municipio" 
    label="text"
    track-by="text"
    :show-labels="false"
    
  >
    <template slot="noOptions">
      <div>
        Lista vacía
      </div>
    </template>
  </multiselect>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'

  import Multiselect from 'vue-multiselect'
  import axios from "axios";
  import config from '../../../helpers/config';

  export default {
    mounted() {
      this.getMunicipalities()
    },
    data () {
      return {
        valuex: [],
        value: [],
        options: [],
      }
    },
    watch: {
      idDepartment(val) {
        this.getMunicipalities(val)
      }
    },
    computed: {
      idDepartment() {
        return this.$store.state.departamento
      }
    },
    methods: {
      ...mapMutations([
        'filterExperiences'
      ]),
      onChange(event){
        //localStorage.setItem("municip_id", event.value)
        this.value = event && event.value ? event.value: false
        this.$store.state.municipio = this.value
        console.log(this.value)
        this.filterExperiences({
          isObject: false,
          isArray: false,
          filter: 'locationMunId',
          id: this.value
        })
      },
      getMunicipalities(dep = 0) {
        this.options = [];
        return axios
          .get(
            `${config.urlApi}/locationMunicipalities?filter[where][locationDepartmentId]=${dep < 10 ? '0' + dep: dep}`,
            {}
          )
          .then(response => {
            response.data.forEach(element => {
              this.options.push({
                value: element.id,
                text: element.municipality
              });
            });
          })
          .catch(function(error) {
            //////console.log(error)
          });
      },
     /*getMunicipalities(){
        axios.get(`${config.urlApi}/locationMunicipalities`, {})
          .then(response => {
              response.data.forEach(element => {
                this.options.push({
                  value: element.id,
                  text: element.municipality
                })
            });
        })
        .catch(function (error) {
         ////console.log(error)
        })
      },*/
    },
    components: {
      Multiselect
    }
  }
</script>
